module.exports = __webpack_public_path__ + "a6fa75bbb559a1fe7b41bbcb5c037208.jpg";